import React from 'react';
import { ChartLabels, TabValues } from '../../DeviceDetails/constants';
import {
    DropdownMenuSub,
    DropdownMenuSubTrigger,
    DropdownMenuLabel,
    DropdownMenuSubContent,
    DropdownMenuCheckboxItem,
} from 'components/shadcn/ui/dropdown-menu';
import { PresentationChartLineIcon } from '@heroicons/react/24/outline';

const ChartTypeSubmenu = ({ chartType, setChartType }) => {
    const menuItems = [
        {
            label: ChartLabels.All,
            value: TabValues.All,
        },
        {
            label: ChartLabels.Temp,
            value: TabValues.Temp,
        },
        {
            label: ChartLabels.Power,
            value: TabValues.Power,
        },
        {
            label: ChartLabels.Voltage,
            value: TabValues.Voltage,
        },
        {
            label: ChartLabels.Current,
            value: TabValues.Current,
        },
        {
            label: ChartLabels.Charge,
            value: TabValues.Charge,
        },
    ];

    return (
        <DropdownMenuSub>
            <DropdownMenuSubTrigger
                className="focus:bg-slate-100 focus:text-accent-foreground data-[state=open]:bg-slate-100"
                arrowLeft
            >
                <PresentationChartLineIcon />
                <DropdownMenuLabel className="p-0">
                    {ChartLabels[chartType?.title] || chartType?.title}
                </DropdownMenuLabel>
            </DropdownMenuSubTrigger>
            <DropdownMenuSubContent>
                {menuItems.map((item, index) => (
                    <DropdownMenuCheckboxItem
                        key={index}
                        checked={chartType?.title === item.value ? true : false}
                        onCheckedChange={() =>
                            setChartType({ title: item.value })
                        }
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </DropdownMenuCheckboxItem>
                ))}
            </DropdownMenuSubContent>
        </DropdownMenuSub>
    );
};

export default ChartTypeSubmenu;
